export default {
  header: {
    title: 'Premi',
  },
  content: {
    title: 'Hai {{balance}} punti',
    description:
      'Spendi {{amount}}, ottieni {{rewards}} punti! Aggiungi articoli gratuiti al carrello con i punti guadagnati.',
    articles: {
      title: 'Guadagna punti ad ogni ordine',
      spend_description: 'Ogni {{amount}} speso aggiunge {{rewards}} punti al tuo account.',
      redeem_title: 'Riscatta i tuoi punti',
      redeem_description:
        'Riscatta i tuoi punti per premi gratuiti! Inizia a guadagnare premi da {{minSpendingLimit}} punti, equivalenti a {{amount}} spesi',
      discounts_title: 'Scopri vantaggi esclusivi',
      discounts_description: 'Sblocca offerte e sconti esclusivi.',
    },
  },
};
